import React, { useCallback, useState } from 'react';
import classes from './style.module.scss';
import Button from '~/app/common/Button';
import { useStoreActions, useStoreState } from '~/store';
import useTranslation from '~/app/hooks/useTranslation';
import { ServiceStatuses } from '~/app/data/statuses/services';
import ConfirmationMenu from '~/app/common/ConfirmationMenu';
import { DeleteServiceResponse } from '~/types';
import { notify } from '~/app/helpers/notify';

export type ServiceActionsComponent = React.FC;

const ServiceActions = () => {

    const { t } = useTranslation('service.serviceClose');
    const status = useStoreState(state => state.service.data.status);
    const netWorkStatus = useStoreState(state => state.app.offline.status);
    const serviceId = useStoreState(actions => actions.service.data.id);

    const fetchService = useStoreActions(actions => actions.service.fetchService);
    const cancelService = useStoreActions(actions => actions.service.cancelService);

    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

    const onCancel = useCallback(() => {
        cancelService(serviceId).then((res: DeleteServiceResponse) => {
            notify(res.msg, res.success ? 'success' : 'error');
            fetchService(serviceId);
        });
        setIsConfirmationOpen(false);
    }, [setIsConfirmationOpen, fetchService, cancelService, serviceId])

    if (netWorkStatus || status !== ServiceStatuses.TRIGGERED) {
        return (<></>);
    }

    return (
        <>
            <div className={`${classes['button']}`}>
                <Button className={`${classes['closeService']}`} onClick={() => setIsConfirmationOpen(true)}> {t('cancelService')} </Button>
            </div>
            <ConfirmationMenu
                isOpen={isConfirmationOpen}
                onConfirm={onCancel}
                onCancel={() => setIsConfirmationOpen(false)}
                confirmationText={t('cancelConfirm')}
            />
        </>
    );
};


export default ServiceActions;